/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT ORDERS PAGE
 -----------------------------------------*/
let ChatManager = (() => {
    const url = '/comments';
    const $form = $('#chat-form');
    const deleteButton = '.delete-comment';
    const commentButton = '.add-comment-button';
    const answerButton = '.add-response-button';
    const loadMoreButton = '#chat-load-more';
    const $messageListBlock = $('#chat-message-list');
    const $inputIsQuestion = $('#message-is-question');

    let init  = () => {
        listenAddComment();
        listenAddAnswer();
        listenLoadMore();
        listenDelete();
    };

    let listenAddComment = () => {
        $(document).on('click', commentButton, function () {
            addComment(this, getCommentData, addCommentLocal);
        });
    };

    let listenAddAnswer = () => {
        $(document).on('click', answerButton, function () {
            addComment(this, getAnswerData, addAnswerLocal);
        });
    };

    let listenLoadMore = () => {
        $(document).on('click', loadMoreButton, function () {
            loadMore();
        });
    };

    let listenDelete = () => {
        $(document).on('click', deleteButton, function () {
            if(confirm('Уверены что хотите удалить сообщение')){
                deleteFromDb(this);
            }
        });
    };

    let addComment = (element, getDataCallback, addCommentCallback) => {
        let input = $(element).siblings('input');
        if (!isEmptyText(input.val())) {
            let data = getDataCallback(input);
            sendRequest(data, addCommentCallback);
        } else {
            alert('Сообщение не может быть пустым');
        }
    };

    let deleteFromDb = (element) => {
        let id = $(element).data('id');
        let messageBlock = $(element).parent().parent();
        $.ajax({
            url: url + '/' + id,
            method: 'POST',
            data: {
                _method: 'DELETE'
            }
        }).done(() => {
            deleteLocal(messageBlock);
        });
    };

    let deleteLocal = (messageBlock) => {
        messageBlock.remove();
    };

    let isEmptyText = (str) => {
        return (!str || 0 === str.length)
    };

    let getCommentData = (input) => {
        return {
            text: input.val(),
            entity_id: $form.data('entity-id'),
            entity_type: $form.data('entity-type'),
            is_question: $inputIsQuestion.prop("checked") ? 1 : 0
        };
    };

    let getAnswerData = (input) => {
        return {
            text: input.val(),
            entity_id: $form.data('entity-id'),
            entity_type: $form.data('entity-type'),
            comment_id: input.data('comment-id')
        };
    };

    let addCommentLocal = (response) => {
        $messageListBlock.append(response);
    };

    let addAnswerLocal = (response, data) => {
        let $messageResponse = $('#response-block-' + data.comment_id);
        $messageResponse.html(response);
    };

    let loadMore = () => {
        $.get(url, {
            entity_id: $form.data('entity-id'),
            entity_type: $form.data('entity-type')
        }).done( (response) => {
            $messageListBlock.html(response);
            $(loadMoreButton).hide();
        });
    };

    let sendRequest = (data, addCommentCallback) => {
        $.ajax({
            url: url,
            type: 'POST',
            data: data
        }).done((response) => {
            addCommentCallback(response, data);
        });
    };

    return {
        init: init
    };
})();

export default ChatManager;
